import Card from "../UI/Card";
import MealItem from "./MealItem/MealItem";
import classes from "./AvailableMeals.module.css";

let DUMMY_MEALS = [
  {
    id: "m1",
    name: "Sushi",
    description: "Les meilleurs poissons et légumes",
    price: 22.99,
  },
  {
    id: "m2",
    name: "Escalope",
    description: "Une spécialité allemande !",
    price: 16.5,
  },
  {
    id: "m3",
    name: "Barbecue Burger",
    description: "Américain avec une viande tendre",
    price: 12.99,
  },
  {
    id: "m4",
    name: "Green Bowl",
    description: "Une salade Healthy",
    price: 18.99,
  },
];

const AvailableMeals = (props) => {
  const mealsList = DUMMY_MEALS.map((meal) => (
    <MealItem
      id={meal.id}
      key={meal.id}
      name={meal.name}
      description={meal.description}
      price={meal.price}
    />
  ));

  return (
    <section className={classes.meals}>
      <Card>
        <ul>{mealsList}</ul>
      </Card>
    </section>
  );
};

export default AvailableMeals;
